<template>
	<div class="app-container">
		<sidebar-menu></sidebar-menu>
		<div class="page-container">
			<topbar></topbar>
			<main class='main-content'>
          	<div id='mainContent'>
				<router-view></router-view>
			</div>
			</main>
		</div>
	</div>
</template>

<script>
    import SidebarMenu from './SidebarMenu';
    import Topbar from './Topbar';
    export default {
        name: 'Frame',
        components: {
            SidebarMenu,
            Topbar
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/layout/Frame.vue